import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupA11yPlugin from "@swup/a11y-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupFragmentPlugin from "../plugins/fragmentPlugin";

export const fragmentPlugin = new SwupFragmentPlugin({
  rules: [],
});

const swup = new Swup({
  animationSelector: false,
  animateHistoryBrowsing: false,
  containers: ["#main"],
  plugins: [
    new SwupA11yPlugin(),
    new SwupPreloadPlugin({ preloadVisibleLinks: true }),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: {
        betweenPages: false,
        samePageWithHash: true,
        samePage: true,
      },
    }),
    fragmentPlugin,
  ],
});

export default swup;
